import { match as locale } from "../../../src/params/locale.js";
import { match as pageNumber } from "../../../src/params/pageNumber.js";

export const matchers = { locale, pageNumber };